/*import { useTranslation } from "react-i18next";*/
import { useEffect, useState } from "react";
import { classNames } from "src/helpers/mixins";

type DialogConfirmParams = {
  show: boolean
  closeDialog(): void 
  children:  JSX.Element | React.ReactNode
  disabledFooter?: boolean
  size?: string
  disabledClosable?:boolean
}

const DialogConfirm = ({show, closeDialog, size, children,disabledFooter,disabledClosable}:DialogConfirmParams) => {
  //const { t } = useTranslation();
  const [animateClose, setAnimateClose] = useState<boolean>(false)
  const willAnimateClose = () => {
    setAnimateClose(true)
    window.setTimeout(() => {
      closeDialog()
      setAnimateClose(false)
    },500)
  }

  useEffect(() => {
    //setAnimateClose(false)
  }, [])
  
  return (
    <>
      {show &&
        <div
          className={classNames("relative z-[14000]", animateClose ? 'fadeout' :'fadein')}
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"></div>

          <div className="fixed inset-0 z-[14000] w-screen overflow-y-auto">
            <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
              <div className={classNames(`relative transform rounded-2xl bg-white text-left shadow-2xl transition-all duration-300 sm:my-8 w-11/12 scale-100`, (size ? `xl:${size}` : `xl:w-1/2`), animateClose ? 'scale-95 opacity-0' : 'scale-100 opacity-100')}>
                {!disabledClosable && 
                  <div
                    aria-label="cerrar"
                    role="button"
                    onClick={() => willAnimateClose()}
                    className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white transition-all duration-200 flex items-center font-bold justify-center text-lg cursor-pointer w-9 h-9 z-[50] rounded-full absolute -right-3 -top-3 shadow-lg hover:shadow-xl hover:scale-110 active:scale-95"
                    style={{ zIndex: 50 }}
                  >
                    ×
                  </div>
                }
                <div className="bg-white relative rounded-2xl overflow-hidden">
                  <div>
                  {children}
                  </div>
                  {!disabledFooter &&
                    <div className="flex flex-row gap-3 items-center px-4 md:px-10 pb-4 justify-center border-t border-gray-200 bg-gradient-to-b from-white to-gray-50">
                      <button 
                        onClick={() => willAnimateClose()} 
                        className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 rounded-xl font-semibold text-base px-8 py-2.5 text-white text-center shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105 active:scale-95"
                      >
                        OK
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
export default DialogConfirm;
